import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
      // variations: true,
    },

    themes: {
      light: {
        // primary: "#2196f3",
        // secondary: "#9c27b0",
        // accent: "#ff5722",
        // error: "#f44336",
        // warning: "#ffeb3b",
        // info: "#ffa9f4",
        // success: "#8bc34a",
      },
    },
  },
});
